/**
 * Module Loader
 *
 * Initialise les modules JS uniquement si leur markup est présent dans le DOM.
 * Imports statiques : évite les chunks async (swiper.js, carte-services.js) que
 * WordPress n'enqueue pas et qui provoquent des ChunkLoadError en production.
 */

import { initSliders } from './swiper';
import { initCarteServicesMaps } from './carte-services';

/**
 * Module registry.
 * Chaque entrée associe un sélecteur DOM à une fonction d'initialisation.
 */
const MODULE_REGISTRY = [
    {
        selector: '[data-slider]',
        init: () => initSliders(),
    },
    {
        selector: '[data-carte-services-map]',
        init: () => initCarteServicesMaps(),
    },
];

/**
 * Initialise les modules dont le markup est présent sur la page.
 */
export function initLazyModules() {
    MODULE_REGISTRY.forEach(({ selector, init }) => {
        if (!document.querySelector(selector)) {
            return;
        }

        try {
            init();
        } catch (error) {
            console.error(
                `[Highfive FSE] Failed to load module for "${selector}":`,
                error
            );
        }
    });
}
